import { api_autocomplete_entities_path, api_create_entity_path } from '../../routes';
import request from './request';

export interface SanitizedAutocompleteEntityParams {
  fragment: string;
  entity_type?: string;
  word_type?: string;
  entity_source_attribute?: string;
  order_entities_by?: string[];
  entity_sources?: string[];
  match_type?: string;
}

export interface EntityObj {
  field: string;
  value: number;
}

export const MATCH_EXACT = 'exact';
export const MATCH_SLUG = 'slug';
export const MATCH_FUZZY = 'fuzzy';

export async function autocompleteEntities(
  values: SanitizedAutocompleteEntityParams
): Promise<EntityObj[]> {
  const resp = await request('get', api_autocomplete_entities_path(values));
  return resp.entities;
}

export interface SanitizedEntityParams {
  name: string;
  entity_type: string;
  word_type: string;
}

type createEntityResponse = { success: boolean; id?: number; errors?: string };

export async function createEntity(values: SanitizedEntityParams): Promise<createEntityResponse> {
  const resp = await request('post', api_create_entity_path(values));
  return resp;
}
